import React, {Component} from 'react';
import classNames from 'classnames';
import {ShipContext} from './context/ShipContext';
import Hotspot from './Hotspot';
import {capitalizeFirstLetter} from "../../utils";

class HotspotOnCloseupImage extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            areaId,
            activeSubareaId,
            ship,
            areaName,
            hotspotLabelText,
            isHoveringOverOtherHotspots,
            handleHotspotClick,
            handleMouseEnterOnHotspot,
            handleMouseLeaveFromHotspot
        } = this.props;

        const
            hotspotClasses = classNames(
                'hotspot hotspot--ship-interior js-hotspot',
                {'hotspot--active': areaId === activeSubareaId && !isHoveringOverOtherHotspots}
            ),
            shipType = capitalizeFirstLetter(ship),
            id = `${areaName}${shipType}`;

        return (
            <Hotspot
                hotspotClasses={hotspotClasses}
                id={id}
                style={{}}
                onClick={() => handleHotspotClick(areaId)}
                onMouseEnter={handleMouseEnterOnHotspot}
                onMouseLeave={() => handleMouseLeaveFromHotspot(areaId === activeSubareaId)}
                labelText={hotspotLabelText}
            />
        )
    }
}

function HotspotOnCloseupImageWithContext(props) {
    return (
        <ShipContext.Consumer>
            {(context) =>
                <HotspotOnCloseupImage
                    handleHotspotClick={context.setActiveSubareaId}
                    activeSubareaId={context.activeSubareaId}
                    ship={context.shipType}
                    {...props}
                />
            }
        </ShipContext.Consumer>
    )
}

export default HotspotOnCloseupImageWithContext;